import HeroSection from "./components/HeroSection";

const About = () => {

  const data = {
    name: "MEDICARE+ CLINIC",
  };

  return (
    <>
      <HeroSection myData={data} />
    </>
  );
};

export default About;
